import { Resource as a, API as e } from "@coveo/platform-client";
const i = class i extends a {
  /**
   * Returns a list of models for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve security identities.
   * @param {string[]} engineIds Engines IDs of the machine learning models to request.
   * @returns {Promise<MLListingModel>} List of machine learning models.
   */
  listModelsByProjectId(r, s = []) {
    return this.api.get(
      this.buildPath(`${i.baseUrl}/project`, {
        projectId: r,
        engineIds: s
      })
    );
  }
};
i.baseUrl = `/rest/organizations/${e.orgPlaceholder}/machinelearning/configuration/modellisting`;
let t = i;
export {
  t as ModelsInternalResource
};
//# sourceMappingURL=ModelsInternalResource.js.map
